<template>
  <div
    v-if="status == 'success'"
    class="list"
  >
    <NuxtLink
      v-for="item in MajorCities[props.areaId]"
      :key="item.point_id"
      :to="isExternalLink ? `${runtimeConfig.app.baseURL}${item.point_id.replace(/^\//, '')}` :item.point_id"
      :external="isExternalLink"
      class="link"
    >
      <div class="text">
        <figure class="flag">
          <img
            :src="`${runtimeConfig.public.gvsUrl}/onebox/img/world/flag/${item.cc}.webp`"
            width="20"
            height="15"
            alt=""
          >

        </figure>
        <div class="inner">
          <p class="area">
            {{ item.label }}
          </p>
          <p class="time">
            {{ dayjs.unix(now).tz(item.timezone).format("H時") }}
          </p>
        </div>
      </div>
      <div class="info">
        <figure class="icon">
          <img
            :src="'https://gvs.weathernews.jp/onebox/img/wxicon/'+ data[item.point_id].wx +'.webp'"
            width="34"
            height="25"
            loading="lazy"
            alt=""
          >
        </figure>
        <div class="temp">
          <p class="max">
            {{ data[item.point_id].maxt }}℃
          </p>
          <p class="min">
            {{ data[item.point_id].mint }}℃
          </p>
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import MajorCities from '~/data/table/major_city_list.json'

dayjs.extend(utc)
dayjs.extend(timezone)

const props = defineProps({
  now: {
    type: Number,
    required: true
  },
  areaId: {
    type: String,
    required: true
  }
})

const { data, status } = await useFetch(`/api/point/weather?pointId=${MajorCities[props.areaId].map((v) => v.point_id).join(',')}`, {
  transform: (data) => {
    return formatMajorCityWeather(MajorCities[props.areaId].map((v) => v.point_id), data, props.now)
  }
})

const runtimeConfig = useRuntimeConfig()
const { $isWebViewFlag:isWebViewFlag } = useNuxtApp()
const isExternalLink = ref(isWebViewFlag)
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid #CCC;
  border-left: 1px solid #CCC;
}
.link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  width: 50%;
  padding: 6px;
  background-color: #FFF;
  border-bottom: 1px solid #CCC;
  border-right: 1px solid #CCC;
}
.text {
  display: flex;
  align-items: center;
  gap: 3px;
  .inner {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
  }
  .flag{
      border: #ccc solid 1px;
      border-radius: 50%;
      overflow: hidden;
      aspect-ratio: 1;
      img {
        display: block;
        filter: saturate(60%) brightness(130%);
        object-fit: cover;
        height: 100%;
      }
  }
  .area {
    color: #3569C0;
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    text-decoration: underline;
  }
  .time {
    color: #606060;
    font-size: 10px;
    line-height: 1em;
  }
}
.info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 3px;
  min-width: 63px;
  .icon {
    width: 30px;
    aspect-ratio: 34 / 25;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .temp {
    display: flex;
    flex-direction: column;
    gap: 3px;
    p {
      text-align: right;
      font-size: 12px;
      font-weight: 600;
      line-height: 1em;
      &.max {
        color: #F64D00;
      }
      &.min {
        color: #0075F3;
      }
    }
  }
}

@media (any-hover: hover) {
  .link {
      transition: opacity .2s ease-in-out;
      &:hover {
        opacity: .6;
      }
  }
}

@media screen and (min-width: 830px) {
  .list {
    gap: 7px;
    border-top: none;
    border-left: none;
  }
  .link {
    display: flex;
    align-items: center;
    gap: 8px;
    width: calc((100% - 14px) / 3);
    padding: 3px 8px;
    background-color: #FFF;
    border: 1px solid #CCC;
    border-radius: 3px;
  }
  .text {
    .area {
      text-align: center;
    }
    .time {
      text-align: left
    }
  }
}
</style>
